import { useEffect, useState } from 'react'
import { runWhenTimeReached } from 'shared/utils'

// False once the time is reached, and without a time
export const useIsBeforeTime = (time?: number) => {
  const [isBefore, setIsBefore] = useState(
    () => time !== undefined && Date.now() < time
  )

  useEffect(() => {
    if (time === undefined) {
      setIsBefore(false)
      return
    }

    setIsBefore(Date.now() < time)
    return runWhenTimeReached(time, () => setIsBefore(false))
  }, [time])

  return isBefore
}
